import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { blogPosts } from '../data/blogPosts';
import Header from '../components/Header';
import Footer from '../components/Footer';
import FloatingIcons from '../components/FloatingIcons';

function BlogPosts() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <FloatingIcons />
      <Header />
      <section className="blog-posts-section">
        <div className="container">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <h1 className="blog-posts-title">Blog Posts</h1>
            <p className="blog-posts-subtitle">Technical articles and insights on Salesforce development</p>
          </motion.div>

          <div className="blog-posts-grid">
            {blogPosts.map((post, index) => {
              const formattedDate = new Date(post.date).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              });

              return (
                <motion.div
                  key={post.id}
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  whileHover={{ y: -10, scale: 1.02 }}
                >
                  <Link to={`/blog/${post.id}`} className="blog-post-card">
                    {post.logo && (
                      <div className="blog-post-logo">
                        <img src={post.logo} alt={post.title} />
                      </div>
                    )}
                    <div className="blog-post-content">
                      <h3 className="blog-post-title">{post.title}</h3>
                      <div className="blog-post-meta">
                        <span className="blog-post-date">{formattedDate}</span>
                        {post.tags && post.tags.length > 0 && (
                          <div className="blog-post-tags">
                            {post.tags.filter(tag => tag !== 'Blog Posts').slice(0, 2).map((tag) => (
                              <span key={tag} className="blog-tag-small">{tag}</span>
                            ))}
                          </div>
                        )}
                      </div>
                      {post.excerpt && (
                        <p className="blog-post-excerpt">{post.excerpt}</p>
                      )}
                    </div>
                  </Link>
                </motion.div>
              );
            })}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default BlogPosts;

